import axios, { AxiosResponse, Method } from 'axios'
import _ from 'lodash'
import LoginStore from '@/stores/CommonStores/LoginStore/LoginStore'

/* eslint-disable @typescript-eslint/no-explicit-any */
type RequestProps = {
  method: Method
  url?: string
  path?: string
  query?: { [key: string]: any }
  data?: object
}
/* eslint-enable @typescript-eslint/no-explicit-any */

/**
 * 認証付きのAPI呼び出しを行うための機能を提供するクラス。
 */
class APIAccessor {
  /**
   * API 呼び出しを行う。
   * @param {RequestProps} param リクエストパラメタ
   * @return {Promise<AxiosResponse>} 処理完了を待機するためのPromise
   */
  public static async request<T>(param: RequestProps): Promise<AxiosResponse<T>> {
    const { accessToken } = LoginStore
    if (!accessToken) {
      console.warn('can not find access token. please login before request')
    }

    /* eslint-disable no-underscore-dangle */
    const _query = param.query || {}

    const query = {
      limit: 10000,
      ..._query,
    }

    let url = `${process.env.VUE_APP_API_BASE_URL}/${LoginStore.orgId}/${
      param.path
    }?${APIAccessor.paramsSerializer(query)}`

    if (param.url) {
      url = `${param.url}?${APIAccessor.paramsSerializer(query)}`
    }

    const result = await axios({
      method: param.method,
      url,
      data: param.data,
      headers: {
        'Content-type': 'application/json',
        'X-FLUX-API-TOKEN': accessToken,
      },
    })

    return {
      ...result,
      data: result.data.results || result.data,
    }
  }

  /**
   * 検索クエリのURLエンコードを行う。
   * <p>
   *   クエリに対してaxios標準のURLエンコード処理を行なった場合、
   *   AWS の Application Load Balancer が 400エラーとする問題があったため、
   *   既存のaxiosのURLエンコード処理(axios/lib/helpers/buildURL.js)を
   *   このメソッドの処理で上書きする。
   *   ※encodeURIComponentのみを利用してURLエンコードする
   *   以下のpullリクエストがaxiosに取り込まれれば不要になる予定
   *   https://github.com/axios/axios/pull/2563
   * </p>
   * @param {Object} query 検索リクエストに指定されたクエリオブジェクト
   * @return {string} URLエンコードされた文字列
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static paramsSerializer(query: { [key: string]: any }): string {
    const parts: string[] = []

    Object.keys(query).forEach(name => {
      let key = name
      let val = query[key]
      if (val === null || typeof val === 'undefined') {
        return
      }

      if (_.isArray(val)) {
        key = `${key}[]`
      }

      if (!_.isArray(val)) {
        val = [val]
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      val.forEach((value: any) => {
        let v = value
        if (_.isDate(v)) {
          v = v.toISOString()
        } else if (_.isObject(v)) {
          v = JSON.stringify(v)
        }
        parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`)
      })
    })

    return parts.join('&')
  }
}

export default APIAccessor
